import {useState} from 'react';

export default class DispositivoModel {

  public codDispositivo: any;
  public setCodDispositivo: any;
  public dsDispositivo: any;
  public setDsDispositivo: any;
  public stPermiteContribuicao: any;
  public setStPermiteContribuicao: any;
  public nuOrdem: any;
  public setNuOrdem: any;
  public codPropostaNorma: any;
  public setCodPropostaNorma: any;
  public stAnexarArquivo: any;
  public setStAnexarArquivo: any;
  public stDispositivoOutroMeio: any;
  public setStDispositivoOutroMeio: any;
  public cdSeqTema: any;
  public setCdSeqTema: any;
  public cdSeqTemaNavigation: any;
  public setCdSeqTemaNavigation: any;
  public ultimoProtocolo: any;
  public setUltimoProtocolo: any;
  public stExibirDialogoContribuicao: any;
  public setStExibirDialogoContribuicao: any;

  constructor() {
    [this.codDispositivo, this.setCodDispositivo] = useState('');
    [this.dsDispositivo, this.setDsDispositivo] = useState('');
    [this.stPermiteContribuicao, this.setStPermiteContribuicao] = useState('');
    [this.nuOrdem, this.setNuOrdem] = useState('');
    [this.codPropostaNorma, this.setCodPropostaNorma] = useState('');
    [this.stAnexarArquivo, this.setStAnexarArquivo] = useState('');
    [this.stDispositivoOutroMeio, this.setStDispositivoOutroMeio] = useState('');
    [this.cdSeqTema, this.setCdSeqTema] = useState('');
    [this.cdSeqTemaNavigation, this.setCdSeqTemaNavigation] = useState('');
    [this.ultimoProtocolo, this.setUltimoProtocolo] = useState('');
    [this.stExibirDialogoContribuicao, this.setStExibirDialogoContribuicao] = useState(false);
  }

  sync(entity: any) {
    this.setCodDispositivo(entity.codDispositivo);
    this.setDsDispositivo(entity.dsDispositivo);
    this.setStPermiteContribuicao(entity.stPermiteContribuicao);
    this.setNuOrdem(entity.nuOrdem);
    this.setCodPropostaNorma(entity.codPropostaNorma);
    this.setStAnexarArquivo(entity.stAnexarArquivo);
    this.setStDispositivoOutroMeio(entity.stDispositivoOutroMeio);
    this.setCdSeqTema(entity.cdSeqTema);
    this.setCdSeqTemaNavigation(entity.cdSeqTemaNavigation);
    this.setUltimoProtocolo(entity.ultimoProtocolo);
    this.setStExibirDialogoContribuicao(entity.stExibirDialogoContribuicao);
  }
}
